import React, { createContext, useContext, useState, useCallback, useMemo, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { translations } from "@/i18n/translations";
import { isFrPath } from "@/i18n/paths";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState("en");

  const toggle = useCallback(() => {
    setLang((l) => (l === "en" ? "fr" : "en"));
  }, []);

  const t = useCallback(
    (path) => {
      const keys = path.split(".");
      let val = translations[lang];
      for (const k of keys) {
        if (val && val[k] !== undefined) val = val[k];
        else return path;
      }
      return val;
    },
    [lang]
  );

  const value = useMemo(() => ({ lang, setLang, toggle, t }), [lang, toggle, t]);
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};

// Keeps the language state in sync with the URL: /fr/* renders French,
// everything else renders English. Also updates <html lang> for a11y/SEO.
export const LangSync = () => {
  const { pathname } = useLocation();
  const { setLang } = useContext(LanguageContext);
  useEffect(() => {
    const fr = isFrPath(pathname);
    setLang(fr ? "fr" : "en");
    document.documentElement.lang = fr ? "fr-CA" : "en-CA";
  }, [pathname, setLang]);
  return null;
};
